import React from 'react';


const Kenya = () => {
  return (
    <div>
      
    </div>
  );
}

export default Kenya;
